<template>

</template>

<script type="text/babel">
  const LOGIN_URL = 'login';

  export default {

    data() {
      return {
      }
    },
    beforeCreate(){
      var _this = this;
      this.$store.dispatch('logout').then(function(){
        _this.$router.replace(LOGIN_URL);
      });

    },
    methods:{
    }
  }
</script>



// WEBPACK FOOTER //
// Logout.vue?1c266f92